import * as React from 'react';

import { useIsOrgScopedHome } from 'bundles/unified-common/hooks/useIsOrgScopedHome';

type UnifiedPageRolloutContextType = {
  isInUnifiedPageRollout: boolean;
};

export const UnifiedPageRolloutContext = React.createContext<UnifiedPageRolloutContextType>({
  isInUnifiedPageRollout: false,
});

export const useIsInUnifiedPageRollout = (): boolean => {
  const { isInUnifiedPageRollout } = React.useContext(UnifiedPageRolloutContext);
  return isInUnifiedPageRollout;
};

const UnifiedPageRolloutExperimentDataProvider = ({ children }: { children: React.ReactNode }) => {
  const isOrgScopedHomeEnabled = useIsOrgScopedHome();
  const [value] = React.useState(() => ({
    isInUnifiedPageRollout: isOrgScopedHomeEnabled,
  }));

  return <UnifiedPageRolloutContext.Provider value={value}>{children}</UnifiedPageRolloutContext.Provider>;
};

export default UnifiedPageRolloutExperimentDataProvider;
